// WhatsApp hand-off for the website forms: after a visitor submits a form
// we open a WhatsApp chat with our sales number (+91 9311 57 2747,
// BRAND.whatsapp) with their details already typed in, so the
// conversation continues on WhatsApp.
import { BRAND } from "@/data/site";

export const WHATSAPP_NUMBER = String(BRAND.whatsapp || "919311572747").replace(/\D/g, "");

/** https://wa.me/<number>?text=<message> — opens the WhatsApp app on phones, WhatsApp Web on desktop. */
export function whatsappUrl(text) {
  const t = String(text || "").trim();
  return `https://wa.me/${WHATSAPP_NUMBER}${t ? `?text=${encodeURIComponent(t)}` : ""}`;
}

/**
 * Pre-filled chat text: an intro line followed by "Label: value" lines,
 * skipping empty values.
 * @param {string} intro
 * @param {Array<[string, string|undefined]>} fields
 */
export function leadMessage(intro, fields) {
  const lines = fields
    .filter(([, v]) => v != null && String(v).trim() !== "")
    .map(([k, v]) => `${k}: ${String(v).trim()}`);
  return [intro, ...lines].join("\n");
}

/**
 * Sends the visitor to WhatsApp after a short pause (so they see the
 * "Opening WhatsApp…" confirmation first). Same-tab navigation is used on
 * purpose: a new tab opened after an async request is blocked by most
 * browsers' popup blockers. Returns the URL for a manual fallback link.
 */
export function redirectToWhatsApp(text, { delay = 1500 } = {}) {
  const url = whatsappUrl(text);
  window.setTimeout(() => {
    window.location.assign(url);
  }, delay);
  return url;
}
